import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=8d134592&scoped=true&"
import script from "./CommentsView.vue?vue&type=script&lang=ts&"
export * from "./CommentsView.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsView.vue?vue&type=style&index=0&id=8d134592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d134592",
  null
  
)

export default component.exports